import { AssetType } from '@moment/trading-types/reference-data'

type DescriptionLabelInput = {
  /** `asset_type` — broad bucket: `AssetType.FixedIncome` | `AssetType.Equity` | `AssetType.Fund`. */
  assetType: AssetType | null
  /** `symbol` — populated for equity/fund rows; null for fixed_income. */
  symbol: string | null
  /** Value to render for non-equity rows (e.g. `description_short` or `description`). */
  fallback: string | null
}

export function getDescriptionLabel({
  assetType,
  symbol,
  fallback,
}: DescriptionLabelInput): string | null {
  if (assetType === AssetType.Equity || assetType === AssetType.Fund) {
    return symbol ?? null
  }
  return fallback ?? null
}
